/*
 * @Author: Gang Jiang 
 * @Date: 2025-02-19 22:13:38 
 * @Last Modified by: Gang Jiang
 * @Last Modified time: 2025-02-28 14:07:24
 */
<template>
  <div class="help-page">
    <breadcrumbs url="about-artemis-ads" lastTitle="Seller FAQ"/>
    <div class="docs">
      <h1>Seller General Account Setup</h1>
      <h2>How do I sign up as a seller on Artemis Ads?</h2>
      <p>
        Signing up as a seller is quick and easy! Just follow these 4 steps:
      </p>
      <ul>
        <li>
          Register: Use a valid email address to create your account, and verify
          by clicking a link in an email from ArtemisAds.com
        </li>
        <li>
          Authorize Access: Grant Artemis Ads permission to access Amazon
          Attribution Services.
        </li>
        <li>
          Activate Your Brand(s): Set up your brand’s profile, including logo,
          bio, and commission rate.
        </li>
        <li>
          Activate Products: Add products (using ASINs) under your brand(s) and
          configure individual commission rates if needed.
        </li>
      </ul>
      <p>
        That’s it! You’re ready to start using Artemis Ads to grow your
        business.
      </p>
      <h2>Why do I need to authorize access to Amazon Attribution Services?</h2>
      <p>
        Authorizing access allows Artemis Ads to create Attribution links on
        your behalf, track and optimize your advertising campaigns effectively.
        This ensures your campaigns are accurately measured and perform at their
        best.
      </p>
      <h2>Can I activate multiple brands under one account?</h2>
      <p>Yes!</p>
      <p>
        You can activate and manage multiple brands under a single seller
        account. Each brand will have its own profile and commission rate.
      </p>
      <h2>Quick Tips for Sellers</h2>
      <ul>
        <li>
          Activating all relevant brands and products helps ensure comprehensive
          campaign coverage.
        </li>
        <li>
          Use a professional logo and clear bio for your brand to attract more
          publishers.
        </li>
        <li>
          Set competitive commission rates to attract the best publishers to
          promote your brands and products
        </li>
      </ul>
      <img
        src="seller/seller-general-account-setup-01.png"
        alt="ArtemisAds help center"
      />
      <img
        src="seller/seller-general-account-setup-02.png"
        alt="ArtemisAds help center"
      />
    </div>
  </div>
</template>
<script setup>
import Breadcrumbs from '../breadcrumbs.vue'
</script>